import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton'
import AddIcon from '@material-ui/icons/Add'
import DeleteIcon from '@material-ui/icons/Delete'
import StyleSheet from 'styles'
import { capitalize } from 'utils'
import { Authorization } from 'utils/AuthorizationUtils'

export class NominationListItem extends Component{
  static propTypes = {
    nomination: PropTypes.object.isRequired,
    onDeleted: PropTypes.func
  }
  static defaultProps = {
    onDeleted: (nomination) => {}
  }

  get nomination() {
    return this.props.nomination
  }

  get source() {
    return `${capitalize(this.nomination.source)} nominated`
  }

  get status() {
    switch (this.nomination.status) {
      case 'membership_pending':
        return `User membership pending`
      case 'investor_account_pending':
        return `Investor account awaiting approval`
      case 'good_to_go':
        return `Ready to be actioned upon`
      default:
        return ''
    }
  }

  get canBeAllocated() {
    return this.nomination.status === 'good_to_go' && Authorization.admin
  }

  get name() {
    const accountName = this.nomination.investorAccountName || ''
    const accountEmail = this.nomination.email || ''

    return `${accountName} ${accountEmail}`
  }

  get size() {
    return `${this.nomination.size} ${this.nomination.currency.code}`
  }

  handleAllocate = (nomination) => {
    this.props.onAllocation(nomination)
  }

  render() {
    return(
      <ListItem className={styles.item}>
        <ListItemText primary={`${this.size} \u2015 ${this.name}`} secondary={
          <span>
            <span>{`${this.source} \u2015 ${this.status}`}</span>
          </span>
        }/>
        <ListItemSecondaryAction>
          { this.canBeAllocated &&
            <IconButton aria-label="delete" onClick={ () => this.handleAllocate(this.props.nomination) }>
              <AddIcon />
            </IconButton>
          }
          <IconButton aria-label="delete" onClick={ () => this.props.onDeleted(this.props.nomination) }>
            <DeleteIcon />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
    )
  }
}

const styles = StyleSheet({
  listItemSecondary: {
    '& p':{
      margin: 0
    }
  },
  item: {
    padding: '0 10px',
    wordBreak: 'break-all',
    minHeight: 70,
    textAlign: 'left'
  }
})